import { render, staticRenderFns } from "./NotificationsListItem.vue?vue&type=template&id=77de3558&scoped=true&"
import script from "./NotificationsListItem.vue?vue&type=script&lang=js&"
export * from "./NotificationsListItem.vue?vue&type=script&lang=js&"
import style0 from "./NotificationsListItem.vue?vue&type=style&index=0&id=77de3558&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77de3558",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAvatar } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VCol,VListItem,VListItemAvatar,VListItemContent,VRow})
